import { Card, CardContent, Chip, Typography } from "@mui/material";
import { DataGridPremium } from "@mui/x-data-grid-premium";
import dayjs from "dayjs";
import React, {useState} from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomToolbar from "../components/CustomToolbar";
import localeGrid from "../components/localeGrid";
import { getLogsRefferals } from "../store/slices/logSlice";
import "../styles/operation.css";
import {getTransactions} from "../store/slices/transactionSlice";
import {unwrapResult} from "@reduxjs/toolkit";

function LogsRefferals2() {

  const [perPage, setPerPage] = useState(10);
  const [rows, setRows] = useState([]);
  const [searchTerm, setSearchTerm] = useState(null);
  const [page, setPage] = useState(1);

  const columns = [
    {
      field: 'id',
      headerName: 'ID',
      width: 75
    },
    {
      field: 'user',
      headerName: 'Пользователь',
      width: 150,
      valueGetter: (params) => {
        return params.row.user?.login
      }
    },

    {
      field: 'refferal',
      headerName: 'Реферал',
      width: 150,
      valueGetter: (params) => {
        return params.row.refferal?.login
      }
    },
    {
      field: 'transaction',
      headerName: 'Сумма',
      width: 150,
      valueGetter: (params) => {
        return params.row.transaction?.amount_usdt
      }
    },
    {
      field: 'amount',
      headerName: 'Вознаграждение',
      width: 150,

    },

    {
      field: 'created_at',
      headerName: "Дата создания",
      width: 150,
      valueFormatter: (params) => {
        return dayjs(params.value).format('DD.MM.YYYY HH:mm')
      }
    }
  ];

  const [tableHeight, setTableHeight] = React.useState(
    window.innerHeight - 200
  );
  const dispatch = useDispatch();
  const logs = useSelector((state) => state.log.logs_refferals)

  const resize = async () => {
    console.log(window.innerHeight);
    setTableHeight(window.innerHeight - 200);
  };

  React.useEffect(() => {
    dispatch(
        getLogsRefferals({ page: 1, perPage: perPage, searchTerm: searchTerm })
    )
        .then(unwrapResult)
        .then((result) => {
          console.log(result);
          setRows(result.data.data);
        })
        .catch((error) => {
          console.error(error);
        });

    resize();
    window.addEventListener("resize", resize);
    return () => {
      window.removeEventListener("resize", resize);

    };
  }, []);

  function handlePageChange(page) {
    setPage(page + 1);
    dispatch(
        getLogsRefferals({
          page: page + 1,
          perPage: perPage,
          searchTerm: searchTerm,
        })
    )
        .then(unwrapResult)
        .then((result) => {
          console.log(result);
          setRows(result.data.data);
        })
        .catch((error) => {
          console.error(error);
        });
  }

  const handlePageSizeChange = (newPerPage) => {
    setPerPage(newPerPage);
    console.log(newPerPage);
    console.log(page);

    dispatch(
        getLogsRefferals({
          page: page,
          perPage: perPage,
          newPerPage: newPerPage,
          searchTerm: searchTerm,
        })
    )
        .then(unwrapResult)
        .then((result) => {
          console.log(result);
          setRows(result.data.data);
        })
        .catch((error) => {
          console.error(error);
        });

  };

  const handleFilterModelChange = (model) => {
    console.log(model.quickFilterValues[0]);
    setSearchTerm(model.quickFilterValues[0]);
    dispatch(
        getLogsRefferals({
          page: page,
          perPage: perPage,
          searchTerm: model.quickFilterValues[0],
        })
    )
        .then(unwrapResult)
        .then((result) => {
          console.log(result);
          setRows(result.data.data);
        })
        .catch((error) => {
          console.error(error);
        });
  };

  return (
    <div>
      <Card sx={{ minWidth: 275 }}>
        <CardContent className="text-start p-3">
          <Typography color="text.primary">Логи рефералов</Typography>

          <div className="row">
            <div className="col-12 mt-3">
              <div style={{ height: tableHeight, width: "100%" }}>
                <DataGridPremium
                  getRowClassName={(params) => `color-${params.row.status}`}
                  rows={rows}
                  paginationMode
                  pageSize={perPage}
                  disableColumnFilter={true}
                  onPageSizeChange={handlePageSizeChange}
                  rowsPerPageOptions={[10, 50, 100, 500, 1000]}
                  pagination
                  onPageChange={handlePageChange}
                  onFilterModelChange={handleFilterModelChange}
                  rowCount={logs.meta?.total}
                  columns={columns}
                  components={{ Toolbar: CustomToolbar }}
                  componentsProps={{
                    toolbar: {
                      filename: "Логи рефералов",
                      showQuickFilter: true,
                      quickFilterProps: { debounceMs: 500 },

                    },
                  }}
                  initialState={{
                    sorting: {
                      sortModel: [
                        {
                          field: "created_at",
                          sort: "desc",
                        },
                      ],
                    },
                  }}
                  localeText={localeGrid}
                />
              </div>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}

export default LogsRefferals2;
